import { ValidationResultItem } from '../typings/common';
import { ColumnsSettingsViewDict } from '../typings/common';
import {
    MinusPhraseLibraryGrid,
    MinusPhraseLibraryModalType
} from '../typings/minusPhraseLibrary';

export const REQUEST_MINUS_PHRASE_LIBRARY_GRID_ROW =
    'REQUEST_MINUS_PHRASE_LIBRARY_GRID_ROW';
export type REQUEST_MINUS_PHRASE_LIBRARY_GRID_ROW = typeof REQUEST_MINUS_PHRASE_LIBRARY_GRID_ROW;

export interface RequestMinusPhraseLibraryGridRow {
    type: REQUEST_MINUS_PHRASE_LIBRARY_GRID_ROW;
    index: number;
}

export function requestMinusPhraseLibraryGridRow(
    index: number
): RequestMinusPhraseLibraryGridRow {
    return {
        type: REQUEST_MINUS_PHRASE_LIBRARY_GRID_ROW,
        index
    };
}

export const UPDATE_MINUS_PHRASE_LIBRARY_GRID_DATA =
    'UPDATE_MINUS_PHRASE_LIBRARY_GRID_DATA';
export type UPDATE_MINUS_PHRASE_LIBRARY_GRID_DATA = typeof UPDATE_MINUS_PHRASE_LIBRARY_GRID_DATA;

export interface UpdateMinusPhraseLibraryGridData {
    type: UPDATE_MINUS_PHRASE_LIBRARY_GRID_DATA;
    gridData: MinusPhraseLibraryGrid;
}

export function updateMinusPhraseLibraryGridData(
    gridData: MinusPhraseLibraryGrid
): UpdateMinusPhraseLibraryGridData {
    return {
        type: UPDATE_MINUS_PHRASE_LIBRARY_GRID_DATA,
        gridData
    };
}

export type UPDATE_MINUS_PHRASE_LIBRARY_GRID_COLUMNS_WIDTH = 'UPDATE_MINUS_PHRASE_LIBRARY_GRID_COLUMNS_WIDTH';
export const UPDATE_MINUS_PHRASE_LIBRARY_GRID_COLUMNS_WIDTH =
    'UPDATE_MINUS_PHRASE_LIBRARY_GRID_COLUMNS_WIDTH';

export interface UpdateMinusPhraseLibraryGridColumnsWidth {
    type: UPDATE_MINUS_PHRASE_LIBRARY_GRID_COLUMNS_WIDTH;
    columns: ColumnsSettingsViewDict;
}

export function updateMinusPhraseLibraryGridColumnsWidth(
    columns: ColumnsSettingsViewDict
): UpdateMinusPhraseLibraryGridColumnsWidth {
    return {
        type: UPDATE_MINUS_PHRASE_LIBRARY_GRID_COLUMNS_WIDTH,
        columns
    };
}

export const HANDLE_MINUS_PHRASE_LIBRARY_COLUMNS_WIDTH_UPDATE =
    'HANDLE_MINUS_PHRASE_LIBRARY_COLUMNS_WIDTH_UPDATE';
export type HANDLE_MINUS_PHRASE_LIBRARY_COLUMNS_WIDTH_UPDATE = typeof HANDLE_MINUS_PHRASE_LIBRARY_COLUMNS_WIDTH_UPDATE;

export interface HandleMinusPhraseLibraryColumnsWidthUpdate {
    type: HANDLE_MINUS_PHRASE_LIBRARY_COLUMNS_WIDTH_UPDATE;
    width: number;
    key: string;
}

export function handleMinusPhraseLibraryColumnsWidthUpdate(
    width: number,
    key: string
): HandleMinusPhraseLibraryColumnsWidthUpdate {
    return {
        type: HANDLE_MINUS_PHRASE_LIBRARY_COLUMNS_WIDTH_UPDATE,
        width,
        key
    };
}

export const RESET_MINUS_PHRASE_LIBRARY_GRID_DATA =
    'RESET_MINUS_PHRASE_LIBRARY_GRID_DATA';
export type RESET_MINUS_PHRASE_LIBRARY_GRID_DATA = typeof RESET_MINUS_PHRASE_LIBRARY_GRID_DATA;

export interface ResetMinusPhraseLibraryGridData {
    type: RESET_MINUS_PHRASE_LIBRARY_GRID_DATA;
}

export function resetMinusPhraseLibraryGridData(): ResetMinusPhraseLibraryGridData {
    return {
        type: RESET_MINUS_PHRASE_LIBRARY_GRID_DATA
    };
}

export const OPEN_MINUS_PHRASE_LIBRARY_ADD_LIST_MODAL =
    'OPEN_MINUS_PHRASE_LIBRARY_ADD_LIST_MODAL';
export type OPEN_MINUS_PHRASE_LIBRARY_ADD_LIST_MODAL = typeof OPEN_MINUS_PHRASE_LIBRARY_ADD_LIST_MODAL;

export interface OpenMinusPhraseLibraryAddListModal {
    type: OPEN_MINUS_PHRASE_LIBRARY_ADD_LIST_MODAL;
    index?: string;
}

export function openMinusPhraseLibraryAddListModal(
    index?: string
): OpenMinusPhraseLibraryAddListModal {
    return {
        type: OPEN_MINUS_PHRASE_LIBRARY_ADD_LIST_MODAL,
        index
    };
}

export const OPEN_MINUS_PHRASE_LIBRARY_EDIT_LIST_MODAL =
    'OPEN_MINUS_PHRASE_LIBRARY_EDIT_LIST_MODAL';
export type OPEN_MINUS_PHRASE_LIBRARY_EDIT_LIST_MODAL = typeof OPEN_MINUS_PHRASE_LIBRARY_EDIT_LIST_MODAL;

export interface OpenMinusPhraseLibraryEditListModal {
    type: OPEN_MINUS_PHRASE_LIBRARY_EDIT_LIST_MODAL;
    index: string;
}

export function openMinusPhraseLibraryEditListModal(
    index: string
): OpenMinusPhraseLibraryEditListModal {
    return {
        type: OPEN_MINUS_PHRASE_LIBRARY_EDIT_LIST_MODAL,
        index
    };
}

export const UPDATE_MINUS_PHRASE_LIBRARY_MODAL_STATUS =
    'UPDATE_MINUS_PHRASE_LIBRARY_MODAL_STATUS';
export type UPDATE_MINUS_PHRASE_LIBRARY_MODAL_STATUS = typeof UPDATE_MINUS_PHRASE_LIBRARY_MODAL_STATUS;

export interface UpdateMinusPhraseLibraryModalType {
    type: UPDATE_MINUS_PHRASE_LIBRARY_MODAL_STATUS;
    modalType: MinusPhraseLibraryModalType;
    isVisible: boolean;
}

export function updateMinusPhraseLibraryModalStatus(
    modalType: MinusPhraseLibraryModalType,
    isVisible: boolean
): UpdateMinusPhraseLibraryModalType {
    return {
        type: UPDATE_MINUS_PHRASE_LIBRARY_MODAL_STATUS,
        modalType,
        isVisible
    };
}

export const DELETE_MINUS_PHRASE_LIBRARY_LIST =
    'DELETE_MINUS_PHRASE_LIBRARY_LIST';
export type DELETE_MINUS_PHRASE_LIBRARY_LIST = typeof DELETE_MINUS_PHRASE_LIBRARY_LIST;

export interface DeleteMinusPhraseLibraryList {
    type: DELETE_MINUS_PHRASE_LIBRARY_LIST;
    index: string;
}

export function deleteMinusPhraseLibraryList(
    index: string
): DeleteMinusPhraseLibraryList {
    return {
        type: DELETE_MINUS_PHRASE_LIBRARY_LIST,
        index
    };
}

export const UPDATE_MINUS_PHRASE_LIST_DATA = 'UPDATE_MINUS_PHRASE_LIST_DATA';
export type UPDATE_MINUS_PHRASE_LIST_DATA = typeof UPDATE_MINUS_PHRASE_LIST_DATA;

export interface UpdateMinusPhraseListData {
    type: UPDATE_MINUS_PHRASE_LIST_DATA;
    title: string;
    minusPhrases: string;
}

export function updateMinusPhraseListData(
    title: string,
    minusPhrases: string
): UpdateMinusPhraseListData {
    return {
        type: UPDATE_MINUS_PHRASE_LIST_DATA,
        title,
        minusPhrases
    };
}

export const CLOSE_MINUS_PHRASE_LIBRARY_MODAL =
    'CLOSE_MINUS_PHRASE_LIBRARY_MODAL';
export type CLOSE_MINUS_PHRASE_LIBRARY_MODAL = typeof CLOSE_MINUS_PHRASE_LIBRARY_MODAL;

export interface CloseMinusPhraseLibraryModal {
    type: CLOSE_MINUS_PHRASE_LIBRARY_MODAL;
}

export function closeMinusPhraseLibraryModal(): CloseMinusPhraseLibraryModal {
    return {
        type: CLOSE_MINUS_PHRASE_LIBRARY_MODAL
    };
}

export const CREATE_MINUS_PHRASE_LIBRARY_LIST_DATA =
    'CREATE_MINUS_PHRASE_LIBRARY_LIST_DATA';
export type CREATE_MINUS_PHRASE_LIBRARY_LIST_DATA = typeof CREATE_MINUS_PHRASE_LIBRARY_LIST_DATA;

export interface CreateMinusPhraseLibraryListData {
    type: CREATE_MINUS_PHRASE_LIBRARY_LIST_DATA;
}

export function createMinusPhraseLibraryListData(): CreateMinusPhraseLibraryListData {
    return {
        type: CREATE_MINUS_PHRASE_LIBRARY_LIST_DATA
    };
}

export const EDIT_MINUS_PHRASE_LIBRARY_LIST_DATA =
    'EDIT_MINUS_PHRASE_LIBRARY_LIST_DATA';
export type EDIT_MINUS_PHRASE_LIBRARY_LIST_DATA = typeof EDIT_MINUS_PHRASE_LIBRARY_LIST_DATA;

export interface EditMinusPhraseLibraryListData {
    type: EDIT_MINUS_PHRASE_LIBRARY_LIST_DATA;
}

export function editMinusPhraseLibraryListData(): EditMinusPhraseLibraryListData {
    return {
        type: EDIT_MINUS_PHRASE_LIBRARY_LIST_DATA
    };
}

export const SHOW_MINUS_PHRASE_LIBRARY_ERROR_LIST_DATA =
    'SHOW_MINUS_PHRASE_LIBRARY_ERROR_LIST_DATA';
export type SHOW_MINUS_PHRASE_LIBRARY_ERROR_LIST_DATA = typeof SHOW_MINUS_PHRASE_LIBRARY_ERROR_LIST_DATA;

export interface ShowMinusPhraseLibraryErrorListData {
    type: SHOW_MINUS_PHRASE_LIBRARY_ERROR_LIST_DATA;
    error: ValidationResultItem[];
}

export function showMinusPhraseLibraryErrorListData(
    error: ValidationResultItem[]
): ShowMinusPhraseLibraryErrorListData {
    return {
        type: SHOW_MINUS_PHRASE_LIBRARY_ERROR_LIST_DATA,
        error
    };
}

export type MinusPhraseLibraryAction =
    | UpdateMinusPhraseLibraryGridData
    | HandleMinusPhraseLibraryColumnsWidthUpdate
    | UpdateMinusPhraseLibraryGridColumnsWidth
    | ResetMinusPhraseLibraryGridData
    | OpenMinusPhraseLibraryEditListModal
    | DeleteMinusPhraseLibraryList
    | UpdateMinusPhraseListData
    | CloseMinusPhraseLibraryModal
    | UpdateMinusPhraseLibraryModalType
    | EditMinusPhraseLibraryListData
    | CreateMinusPhraseLibraryListData
    | ShowMinusPhraseLibraryErrorListData
    | OpenMinusPhraseLibraryAddListModal
    | RequestMinusPhraseLibraryGridRow;
